import React from "react";
import NavBar from "./NavBar";
import { Link } from "react-router-dom";

const Header = () => {
    return (
        <React.Fragment>
            <header id="header" class="header d-flex align-items-center sticky-top">
                <div class="container position-relative d-flex align-items-center justify-content-between">

                    <Link to="/" class="logo d-flex align-items-center me-auto me-xl-0">

                        <h1 class="sitename">Yummy</h1>
                        <span>.</span>
                    </Link>

                    <nav id="navmenu" class="navmenu">
                        {/* <ul>
                            <li><a href="/" class="active">Home<br /></a></li>
                            <li><a href="/about">About</a></li>
                            <li><a href="/menu">Menu</a></li>
                            <li><a href="/book-table">Book Table</a></li>
                            <li><a href="/content">Contact</a></li>
                        </ul> */}

                        <ul>
                            <li><Link to="/" className="active">Home</Link></li>
                            <li><Link to="/about">About</Link></li>
                            <li><Link to="/menu">Menu</Link></li>
                            <li><Link to="/book-table">Book Table</Link></li>
                            <li><Link to="/content">Contact</Link></li>
                        </ul>

                        <i class="mobile-nav-toggle d-xl-none bi bi-list"></i>
                    </nav>

                    {/* <a class="btn-getstarted" href="/BookTable">Book a Table</a> */}

                    <div className="d-flex align-items-center gap-2">
                        {/* <a className="btn-getstarted" href="/book-table">
                            Book a Table
                        </a> */}

                        <Link className="btn-getstarted" to="/book-table">
                            Book a Table
                        </Link>

                        <NavBar />
                    </div>

                </div>
            </header>
        </React.Fragment>
    )
}

export default Header;